declare var $: any;

export const BOOTSTRAP_PAGE_BUTTON_RENDERER = 'bootstrap3';

const PAGE_BUTTON_LABELS = {
  first: 'sFirst',
  previous: 'sPrevious',
  next: 'sNext',
  last: 'sLast'
};

/**
 * Registers a Bootstrap 3 `ul.pagination` pager on the active DataTables copy.
 * angular.json loads `datatables.net` after `dataTables.bootstrap.min.js`, which
 * discards the Bootstrap renderer, and the legacy `.withBootstrap()` that re-applied
 * it only ran for AngularJS tables. Ported from DataTables' Bootstrap 3 integration.
 */
export function registerBootstrapPageButtonRenderer() {
  const pageButtonRenderers = $.fn.dataTable.ext.renderer.pageButton;
  if (!pageButtonRenderers[BOOTSTRAP_PAGE_BUTTON_RENDERER]) {
    pageButtonRenderers[BOOTSTRAP_PAGE_BUTTON_RENDERER] = renderPageButtons;
  }
}

function renderPageButtons(settings, host, idx, buttons, page, pages) {
  const api = new $.fn.dataTable.Api(settings);
  const lang = settings.oLanguage.oPaginate;
  const aria = settings.oLanguage.oAria.paginate || {};
  let counter = 0;

  const onClick = (e) => {
    e.preventDefault();
    if (!$(e.currentTarget).hasClass('disabled') && api.page() !== e.data.action) {
      api.page(e.data.action).draw('page');
    }
  };

  const attach = (container, buttonList) => {
    buttonList.forEach((button) => {
      if (Array.isArray(button)) {
        attach(container, button);
        return;
      }
      const isBackward = button === 'first' || button === 'previous';
      const isForward = button === 'next' || button === 'last';
      let display: string;
      let btnClass: string;
      if (button === 'ellipsis') {
        display = '&#x2026;';
        btnClass = 'disabled';
      } else if (isBackward || isForward) {
        display = lang[PAGE_BUTTON_LABELS[button]];
        btnClass = button + ((isBackward ? page > 0 : page < pages - 1) ? '' : ' disabled');
      } else {
        display = String(button + 1);
        btnClass = page === button ? 'active' : '';
      }

      const node = $('<li>', {
        class: settings.oClasses.sPageButton + ' ' + btnClass,
        id: idx === 0 && typeof button === 'string' ? settings.sTableId + '_' + button : null
      })
        .append($('<a>', {
          href: '#',
          'aria-controls': settings.sTableId,
          'aria-label': aria[button],
          'data-dt-idx': counter,
          tabindex: settings.iTabIndex
        }).html(display))
        .appendTo(container);

      settings.oApi._fnBindAction(node, { action: button }, onClick);
      counter++;
    });
  };

  // Redrawing the pager destroys the focused button, so restore focus to its replacement.
  const activeIdx = $(host).find(document.activeElement).data('dt-idx');

  attach($(host).empty().html('<ul class="pagination"/>').children('ul'), buttons);

  if (activeIdx !== undefined) {
    $(host).find('[data-dt-idx=' + activeIdx + ']').focus();
  }
}
